import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import get from 'lodash/get';
import { InView } from 'react-intersection-observer';
import MenuItemCard from 'menus/ui_components/MenuItemCard';
import { mediaQueries, PHONE } from 'base/constants/mediaQueries';

const InterSectionObserver = styled.div`
  width: 100%;
  height: 100%;
  min-height: 172px;
  @media ${mediaQueries[PHONE]} {
    min-height: ${({
      hasImage,
      hasDescription,
      hasLongName,
      hasLongDescription
    }) => {
      /*
        the reason we have this elaborate min height classification
        is on mobile with the intersection observer, when a user navigates
        to menu item and then back to menu, we navigate the user to the same
        y-position they were previously on the menu. But since we render the menu
        again, the intersectional observers haven't been triggered yet. This means
        that without relatively accurate min heights set on these dom elements, the
        browser will scroll to a position y from previous location, but the menu items
        will begin loading during the scroll and change the y position of the browser,
        so that the user loses their place vertically.
      */
      if (hasImage && hasLongDescription && hasLongName) {
        return '317px';
      } else if (
        (hasImage && hasLongDescription) ||
        (hasImage && hasLongName)
      ) {
        return '299px';
      } else if (hasImage && hasDescription) {
        return '278px';
      } else if (hasImage && !hasDescription) {
        return '251px';
      } else {
        return '105px';
      }
    }};
  }
`;

const LONG_NAME_LENGTH = 40;
const LONG_DESC_LENGTH = 50;

class MenuItem extends React.PureComponent {
  static propTypes = {
    handleClick: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    description: PropTypes.string,
    images: PropTypes.array,
    calories: PropTypes.string,
    default_price: PropTypes.string.isRequired,
    spicy: PropTypes.bool,
    vegetarian: PropTypes.bool,
    vegan: PropTypes.bool,
    kosher: PropTypes.bool,
    halal: PropTypes.bool,
    organic: PropTypes.bool,
    inventory: PropTypes.number,
    inventoryLessCart: PropTypes.number,
    shouldLazyLoadMenu: PropTypes.bool
  };

  static defaultProps = {
    handleClick: () => {}
  };

  render() {
    const {
      name,
      description,
      spicy,
      calories,
      vegetarian,
      vegan,
      kosher,
      halal,
      organic,
      images,
      default_price: defaultPrice,
      handleClick,
      inventory,
      inventoryLessCart,
      shouldLazyLoadMenu
    } = this.props;
    const image = get(images, '[0].url', '');
    const isSoldOut = inventoryLessCart === 0;
    const processedHandleClick = isSoldOut ? () => {} : handleClick;
    const rootChild = (
      <MenuItemCard
        name={name}
        description={description}
        calories={calories}
        spicy={spicy}
        vegetarian={vegetarian}
        vegan={vegan}
        kosher={kosher}
        halal={halal}
        organic={organic}
        price={defaultPrice}
        image={image}
        handleClick={processedHandleClick}
        inventory={inventory}
        inventoryLessCart={inventoryLessCart}
      />
    );

    let child = rootChild;
    if (shouldLazyLoadMenu) {
      child = (
        <InView triggerOnce>
          {({ inView, ref, entry }) => (
            <InterSectionObserver
              ref={ref}
              hasImage={!!image}
              hasDescription={!!description}
              hasLongDescription={
                !!description && description.length > LONG_DESC_LENGTH
              }
              hasLongName={name.length > LONG_NAME_LENGTH}
            >
              {inView && rootChild}
            </InterSectionObserver>
          )}
        </InView>
      );
    }

    return child;
  }
}

export default withRouter(MenuItem);
